import httpClient from './httpClient'

const END_POINT = '/api/prematriculas'

const getByPersona = (persona,curso) => httpClient.get(END_POINT, { params: { persona: persona, curso: curso } })

const checkMatricula = (matricula) => httpClient.post(`${END_POINT}/matriculate` , matricula)

const finishMatricula = (numeroPedido,code) => httpClient.post(`${END_POINT}/finish-matriculate` , {codigo: numeroPedido, respuesta: code})

export {

    getByPersona,
    checkMatricula,
    finishMatricula

}